<template>
 <NavBar/>
 <div class="main-content">
   <router-view/>
  </div>
<FooterPage/>
</template>
<script>
import NavBar from '@/components/NavBar.vue'
import FooterPage from './components/FooterPage.vue';
export default{
  components:{
    NavBar, FooterPage
  }
}
</script>
<style>
@font-face {
  font-family: 'montserrat';
  src: url('./assets/fonts/Montserrat-Bold.ttf');
}

@font-face {
  font-family: 'poppins-bold';
  src: url('./assets/fonts/Poppins-Bold.ttf');
}

@font-face {
  font-family: 'poppins-reg';
  src: url('./assets/fonts/Poppins-Regular.ttf');
}

:root{
  --heading: montserrat;
  --text-b: poppins-bold;
  --text: poppins-reg;
  --blue: #15133C;
  --blue2:#645ced;
  --blue3:#362fbb;
  --blue4:#08071b;
  --gold: #EC994B;
  --gold2:rgb(252, 184, 120);
  --gold3:rgb(157, 104, 53);
  --grey: #73777B;
  --light: #F1EEE9;
  --red:rgb(176, 33, 33);
  --lg: 2rem;
  --md: 1.5rem;
  --sm: 1rem;
  --xs: 0.8rem;
  --radius:8px;
  --image: url('./assets/images/bg.jpg');
  --tools: url('./assets/images/tools.jpg');
  --code: url('./assets/images/code.jpg');
  --projects: url('./assets/images/projects.jpg');
}

.main-content{
  min-height:100vh;
}

.heading{
  font-family: var(--heading);
  
}

.heading2{
  font-family: var(--heading);
}

.button-link{
  background-color:var(--blue);
  color:white;
  text-decoration: none;
  padding:0.8rem 1rem;
  border-radius: var(--radius);
  margin-bottom:-3rem;
  transition:0.4s;
}

.button-link:hover{
  background-color:var(--gold);
}

.card-heading{
  font-family: var(--heading);
  font-size:2rem;
}
.card-subheading{
  margin:1rem 0rem;
}

.tiny-icon{
  height:2rem;
}

.foot-heading{
        font-family: var(--heading);
        font-size:1rem;
        margin-bottom:0.6rem;
    }

.button-link2{
  color:white;
  text-decoration:none;
  text-transform: uppercase;
  border:2px solid white;
  padding:0.5rem 1rem;
  font-size:1.3rem;
  min-width:8rem;
  text-align:center;
  transition:0.4s;

}

.button-link2:hover{

  color:transparent;
  background-color: white;
}

.code-button:hover{
  color:var(--red);
}

.tools-button:hover{
  color:var(--blue);
}

.heading3{
  font-family: var(--heading);
  font-size:3rem;
  color:var(--gold);
}

.heading4{
  font-family: var(--heading);
  font-size:2rem;
  color:var(--gold);
}

.sub-heading{
  font-family: var(--heading);
}

body{
  margin:0;
  font-family: var(--text);
  /* background-color: #2c3e50; */

}

.section{
  min-height:20rem;
  /* border:1px solid red; */
  
}


nav {
  padding: 0.3rem;
  /* border:1px solid; */

}

.card{
  color:white;
}

.card-content{
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top:2rem;

}






@media(max-width: 768px){
  .section{
  min-height:20rem;
  padding-bottom:2rem;
  
  /* border:1px solid red; */ 
}

.heading4{
  font-size:1.4rem;
}

.button-link2{

  font-size:1rem;
  min-width:8rem;


}

}


</style>
